import { IAction } from '../../models/ActionModels';
import { EventContainer } from '../EventContainer';

export const ListenerMiddleware = (store: any) => (next: any) => (
  action: IAction
) => {
  const evt = EventContainer.CreateCustomEvent('change', {
    detail: { type: action.type, subtype: action.subtype },
  });
  next(action);
  EventContainer.DispatchEvent(evt, action.type);
  EventContainer.DispatchEvent(evt, action.subtype);
  EventContainer.DispatchEvent(evt, action.type + '_' + action.subtype);
};
